module.exports = __webpack_public_path__ + "static/img/cloud_ass.c667525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cloud_ass.png
// module id = D8DG
// module chunks = 0